//
// FormAppConfig.js
//
import React from 'react'

const CommentsConfig = {
	settings: {
		layout: {
			config: {
				navbar: {
					display: false
				},
				toolbar: {
					display: false
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	},
	auth: ['guest'],
	routes: [
		{
			path: '/comments/:rowguid/:settings',
			component: React.lazy(() => import('./CommentsSidebarContent'))
		}
	]
}

export default CommentsConfig
